import script from "./index.vue?vue&type=script&setup=true&lang=js"
export * from "./index.vue?vue&type=script&setup=true&lang=js"

import "./index.vue?vue&type=style&index=0&id=0931b6cf&lang=scss&scoped=true"

import exportComponent from "/Users/mac/projects/outproject/buge_project/xchatbuge/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0931b6cf"]])

export default __exports__